import { MDBContainer } from "mdb-react-ui-kit";
import { useEffect, useState } from "react";
import useWindowDimensions from "../../components/common/window-dimension";

//component
import Header from "../../components/header/header-one";
import Sidebar from "../../components/sidebar/sidebar-one";
import PaymentListing from "./component/listing";
import Gif from "../../assets/fonts/loader/loader.gif";
import QrCodeScanner from "../../components/modal/qr.payment.scanner";

//service
import apiServices from "../../services/api.services";

export default function Payment() {
  const [loader, setLoader] = useState(false);

  const [openSideBar, setOpenSideBar] = useState(true);
  //data for api
  const [type, setType] = useState("payment"); //control role
  const [start, setStart] = useState(0); //paginate
  const [length, setLength] = useState(10); //paginate
  const [order, setOrder] = useState("desc"); // asc or desc
  const [search, setSearch] = useState("");
  const [startDate, setStartDate] = useState(); //filter date
  const [endDate, setEndDate] = useState(); //filter date
  //date for render
  const [listingData, setListingData] = useState([]);

  const [totalRecords, setTotalRecords] = useState(0);
  const [displayRecords, setDisplayRecords] = useState(0);
  //handle modalbox
  const [actionValue, setActionValue] = useState(false);
  const [createModal, setCreateModal] = useState(false);
  const [selectedId, setSelectedId] = useState("selectedId");
  const [openQrCodeScan, setOpenQrCodeScan] = useState(false);
  const [infoModalBoxData, setInfoModalBoxData] = useState({});
  const [infoData, setInfoData] = useState("");
  const { height, width } = useWindowDimensions();

  useEffect(() => {
    if (width >= "767") {
      setOpenSideBar(true);
    } else {
      setOpenSideBar(false);
    }
  }, [width]);
  const handleOpenSideBar = () => {
    setOpenSideBar(!openSideBar);
  };

  const getListing = async () => {
    const response = await apiServices.walletReport({
      type,
      search,
      order,
      startDate,
      endDate,
      length,
      start,
      status: "completed",
      columns: "created_at",
    });
    if (response) {
      setLoader(false);
      setListingData(response.aaData);
      setTotalRecords(response.iTotalRecords);
      setDisplayRecords(response.iTotalDisplayRecords);
    }
  };

  const getInfoDetail = async () => {
    const response = await apiServices.getPlanningInfo(selectedId);
    if (response) {
      setInfoModalBoxData(response);
    }
  };

  const handleOpenQrCodeScan = () => {
    setOpenQrCodeScan(!openQrCodeScan);
  };

  useEffect(() => {
    if (search === "") {
      // setLoader(true);
    }
    getListing();
  }, [search, length, start]);

  // useEffect(() => {
  //   if (actionValue == "information" && selectedId >= 0) {
  //     getInfoDetail();
  //   }
  // }, [selectedId]);

  return (
    <MDBContainer className="main-container" breakpoint="none">
      <div className="grid-container">
        <Sidebar isOpen={openSideBar} handleSideBar={handleOpenSideBar} />
        {openQrCodeScan && (
          <QrCodeScanner
            show={true}
            close={handleOpenQrCodeScan}
            getListing={getListing}
          />
        )}
        <div className="page-container">
          <Header
            handleSideBar={handleOpenSideBar}
            handleOpenQrCodeScan={handleOpenQrCodeScan}
          />
          {loader ? (
            <div className="loader">
              <img src={Gif} />
            </div>
          ) : (
            <PaymentListing
              length={length}
              start={start}
              listingData={listingData}
              totalRecords={totalRecords}
              displayRecords={displayRecords}
              setListingData={setListingData}
              setSearch={setSearch}
              setStartDate={setStartDate}
              setEndDate={setEndDate}
              setOrder={setOrder}
              setLength={setLength}
              setStart={setStart}
            />
          )}
        </div>
      </div>
    </MDBContainer>
  );
}
